/**
 * Convivência entre a versão clássica e a nova de uma tela, com a escolha gravada por usuário no servidor. Até a
 * virada a clássica é a padrão e a nova é opcional; a partir dela a nova é a padrão para todos, e a clássica só abre
 * para quem a escolher depois da virada. Por isso a escolha da clássica tem dois valores: 'antiga' antes da virada,
 * que deixa de valer nela, e 'classica' depois.
 */
export type VersaoDaTela = 'antiga' | 'nova'

export type EscolhaDeVersao = 'antiga' | 'classica' | 'nova'

const ESCOLHAS: EscolhaDeVersao[] = ['antiga', 'classica', 'nova']

/** Valor gravado no servidor como escolha; qualquer outra coisa conta como "ainda não escolheu". */
export const lerEscolhaDeVersao = (valor: unknown): EscolhaDeVersao | null =>
	ESCOLHAS.includes(valor as EscolhaDeVersao) ? (valor as EscolhaDeVersao) : null

/** No relógio de quem abre a tela. */
export const passouDaVirada = (virada: Date, agora: Date) => agora.getTime() >= virada.getTime()

/** escolha null: o usuário nunca escolheu. */
export function versaoQueAbre(escolha: EscolhaDeVersao | null, virada: Date, agora: Date): VersaoDaTela {
	if (!passouDaVirada(virada, agora)) return escolha === 'nova' ? 'nova' : 'antiga'
	return escolha === 'classica' ? 'antiga' : 'nova'
}

/** O que gravar quando o usuário troca para a versão. */
export function escolhaAoTrocar(versao: VersaoDaTela, virada: Date, agora: Date): EscolhaDeVersao {
	if (versao === 'nova') return 'nova'
	return passouDaVirada(virada, agora) ? 'classica' : 'antiga'
}
